import { InventoryField } from 'common/modules/inventory';
import { newFirestoreId } from 'common/utils/newRentalUtils';
import { TFunction } from 'i18next';
import { FixedArticleColumns } from 'views/Inventory/ArticlesView/ArticlesTable/columns';
import { DataRowObject } from '../utils';

export interface ColumnImportData {
	toAdd: InventoryField[];
	toUpdate: {
		[customField: string]: string;
	};
	invalid: {
		[fieldName: string]: string;
	};
}

export const getColumnImportData = (
	headerRow: DataRowObject,
	customInventoryFields: InventoryField[],
	t: TFunction,
): ColumnImportData => {
	const customInventoryFieldNames = customInventoryFields.map((field) => field.label);
	const importColumns = Object.entries(headerRow).reduce(
		(tot, [key, value]) => {
			if (FixedArticleColumns[key]) return tot;
			const fieldId = key || newFirestoreId();
			const previouslyUpdatedLabels = [
				...tot.toAdd.map((c) => c.label),
				...Object.values(tot.toUpdate),
			];
			const existingFieldMatch = customInventoryFields.find((field) => field.id === fieldId);
			if (!!existingFieldMatch && existingFieldMatch.label === value) return tot;
			if (customInventoryFieldNames.includes(value) || previouslyUpdatedLabels.includes(value)) {
				return {
					...tot,
					invalid: {
						...tot.invalid,
						[value]: t('inventory.specificationAlreadyExists'),
					},
				};
			}
			if (!!existingFieldMatch) {
				if (existingFieldMatch.label === value) return tot;
				return {
					...tot,
					toUpdate: {
						...tot.toUpdate,
						[fieldId]: value,
					},
				};
			}
			const newField: InventoryField = {
				id: fieldId,
				label: value,
				type: 'text',
				values: [],
			};
			return {
				...tot,
				toAdd: [...tot.toAdd, newField],
			};
		},
		{ toAdd: [], toUpdate: {}, invalid: {} } as ColumnImportData,
	);
	return importColumns;
};
